@if (quotation().id_factura) {
  <div class="payments-header" appStickyHeaderHeight>
    <h2 class="payments-header__title">
      {{ 'global.payments.register-tab' | translate }}
      @if (invoiceConsecutiveNumber) {
        {{ invoiceConsecutiveNumber }}
      }
    </h2>
    @if (dianInvoiceNumber) {
      <p class="payments-header__dian">{{ dianInvoiceNumber }}</p>
    }
    @if (customerDisplayName) {
      <p class="payments-header__customer">{{ customerDisplayName }}</p>
    }
  </div>
}

<v-one-tabs
  [tabs]="tabs()"
  [activeTabId]="currentTabId()"
  [style.--payments-header-height]="(stickyHeader()?.height() ?? 0) + 'px'"
  className="v-one-tabs--sticky"
  [swipeable]="true"
  (tabChange)="onTabChange($event)"
></v-one-tabs>

<ng-template #summaryTiles>
  <div class="payments-summary">
    <div class="payments-summary__tile">
      <span class="payments-summary__label">{{
        'global.payments.total-invoice' | translate
      }}</span>
      <span class="payments-summary__value">{{
        totalQuot() | currency: 'USD'
      }}</span>
    </div>
    <div class="payments-summary__tile">
      <span class="payments-summary__label">{{
        'global.payments.paid-amount' | translate
      }}</span>
      <span class="payments-summary__value">{{
        appliedPaidTotal | currency: 'USD'
      }}</span>
    </div>
    <div class="payments-summary__tile">
      <span class="payments-summary__label">{{
        'global.payments.pending-amount' | translate
      }}</span>
      <span
        class="payments-summary__value"
        [class.payments-summary__value--pending]="appliedPendingBalance > 0"
        >{{ appliedPendingBalance | currency: 'USD' }}</span
      >
    </div>
    <div class="payments-summary__tile payments-summary__tile--status">
      <span class="payments-summary__label">{{
        'global.payments.status' | translate
      }}</span>
      @if (isVoidedInvoice) {
        <span class="payments-summary__value payments-summary__value--voided">{{
          'card.paymentStatus.voided' | translate
        }}</span>
      } @else if (isFullyPaid) {
        <span class="payments-summary__value payments-summary__value--paid">{{
          'card.paymentStatus.paid' | translate
        }}</span>
      } @else if (hasAssociatedPayments) {
        <span
          class="payments-summary__value payments-summary__value--partial"
          >{{ 'card.paymentStatus.partial' | translate }}</span
        >
      } @else {
        <span
          class="payments-summary__value payments-summary__value--pending"
          >{{ 'global.payments.status-pending' | translate }}</span
        >
      }
    </div>
  </div>
</ng-template>

<ng-template #registerTab>
  <ng-container *ngTemplateOutlet="summaryTiles"></ng-container>

  @if (hasAdvancePayment || hasCreditBalance) {
    <div class="payments-balances">
      <div
        class="payments-balances__row"
        [class.payments-balances__row--has-remove-actions]="
          useAdvancePayment() || useCreditBalance()
        "
      >
        <div class="payments-balances__options">
          @if (hasAdvancePayment) {
            <label
              class="payments-balances__option"
              [class.payments-balances__option--active]="useAdvancePayment()"
            >
              <input
                type="radio"
                name="payments-balance-source"
                class="payments-balances__radio"
                [checked]="useAdvancePayment()"
                (change)="onToggleAdvancePayment($event)"
              />
              <span class="payments-balances__label">
                {{ 'global.payments.use-advance-payment' | translate }} ({{
                  advancePaymentTotal | currency: 'USD'
                }})
              </span>
            </label>
          }
          @if (hasCreditBalance) {
            <label
              class="payments-balances__option"
              [class.payments-balances__option--active]="useCreditBalance()"
            >
              <input
                type="radio"
                name="payments-balance-source"
                class="payments-balances__radio"
                [checked]="useCreditBalance()"
                (change)="onToggleCreditBalance($event)"
              />
              <span class="payments-balances__label">
                {{ 'global.payments.use-credit-balance' | translate }} ({{
                  positiveBalanceValue() | currency: 'USD'
                }})
              </span>
            </label>
          }
        </div>
        @if (useAdvancePayment() || useCreditBalance()) {
          <div class="payments-balances__remove-actions">
            <v-one-button
              [text]="'global.payments.remove-payment-action' | translate"
              icon="trash"
              variant="secondary"
              className="payments-balances__remove-button"
              (buttonClick)="removeBalanceApplicationSelection()"
            />
          </div>
        }
      </div>

      @if (useAdvancePayment()) {
        <div class="payments-balances__table">
          <div class="payments-balances__table-header">
            @if (hasMultipleAdvancePayments) {
              <span
                class="payments-balances__col payments-balances__col--select"
                >{{ 'global.payments.advance-select' | translate }}</span
              >
            }
            <span class="payments-balances__col payments-balances__col--bank">{{
              'global.payments.advance-bank' | translate
            }}</span>
            <span
              class="payments-balances__col payments-balances__col--customer"
              >{{ 'global.payments.advance-customer' | translate }}</span
            >
            <span class="payments-balances__col payments-balances__col--note">{{
              'global.payments.advance-note' | translate
            }}</span>
            <span
              class="payments-balances__col payments-balances__col--value"
              >{{ 'global.payments.value' | translate }}</span
            >
            <span
              class="payments-balances__col payments-balances__col--available"
              >{{ 'global.payments.advance-available' | translate }}</span
            >
          </div>
          @for (payment of advancePayments(); track payment.id_treasury) {
            <div
              class="payments-balances__table-row"
              [class.payments-balances__table-row--active]="
                selectedAdvancePaymentId() === payment.id_treasury
              "
            >
              @if (hasMultipleAdvancePayments) {
                <span
                  class="payments-balances__col payments-balances__col--select"
                >
                  <input
                    type="radio"
                    name="advance-payment-selection"
                    class="payments-balances__radio"
                    [checked]="
                      selectedAdvancePaymentId() === payment.id_treasury
                    "
                    (change)="onSelectAdvancePayment(payment.id_treasury)"
                  />
                </span>
              }
              <span class="payments-balances__col payments-balances__col--bank">
                <span class="payments-balances__col-label">{{
                  'global.payments.advance-bank' | translate
                }}</span>
                {{ payment.paymentType.description }}
              </span>
              <span
                class="payments-balances__col payments-balances__col--customer"
              >
                <span class="payments-balances__col-label">{{
                  'global.payments.advance-customer' | translate
                }}</span>
                {{ payment.customer?.nombre || '-' }}
              </span>
              <span class="payments-balances__col payments-balances__col--note">
                <span class="payments-balances__col-label">{{
                  'global.payments.advance-note' | translate
                }}</span>
                {{ payment.identifier || '-' }}
              </span>
              <span
                class="payments-balances__col payments-balances__col--value"
              >
                <span class="payments-balances__col-label">{{
                  'global.payments.value' | translate
                }}</span>
                {{ payment.value | currency: 'USD' }}
              </span>
              <span
                class="payments-balances__col payments-balances__col--available"
              >
                <span class="payments-balances__col-label">{{
                  'global.payments.advance-available' | translate
                }}</span>
                {{
                  calculateAvailable(payment.value, payment.value_used)
                    | currency: 'USD'
                }}
              </span>
            </div>
          }
        </div>
      }

      @if (useAdvancePayment() && selectedAdvancePaymentId() !== null) {
        <div class="payments-balances__value-row">
          <div class="payments-balances__value-field">
            <v-one-input
              type="text"
              [label]="'global.payments.advance-value-label' | translate"
              placeholder="$ 0"
              [required]="true"
              [formControl]="advanceValueControl"
            />
          </div>
          <label class="payments-balances__full-amount-label">
            <input
              type="checkbox"
              class="payments-balances__checkbox"
              [checked]="useFullAdvanceAvailable()"
              (change)="onToggleFullAdvanceAmount($event)"
            />
            {{ 'global.payments.advance-use-full-available' | translate }}
          </label>
        </div>
      }

      @if (useCreditBalance()) {
        <div class="payments-balances__table payments-balances__table--credit">
          <div class="payments-balances__table-header">
            <span
              class="payments-balances__col payments-balances__col--credit-total"
              >{{ 'global.payments.credit-balance-total' | translate }}</span
            >
            <span
              class="payments-balances__col payments-balances__col--available"
              >{{ 'global.payments.advance-available' | translate }}</span
            >
          </div>
          <div class="payments-balances__table-row">
            <span
              class="payments-balances__col payments-balances__col--credit-total"
            >
              <span class="payments-balances__col-label">{{
                'global.payments.credit-balance-total' | translate
              }}</span>
              {{ positiveBalanceValue() | currency: 'USD' }}
            </span>
            <span
              class="payments-balances__col payments-balances__col--available"
            >
              <span class="payments-balances__col-label">{{
                'global.payments.advance-available' | translate
              }}</span>
              {{ positiveBalanceValue() | currency: 'USD' }}
            </span>
          </div>
        </div>

        <div class="payments-balances__value-row">
          <div class="payments-balances__value-field">
            <v-one-input
              type="text"
              [label]="'global.payments.advance-value-label' | translate"
              placeholder="$ 0"
              [required]="true"
              [disabled]="useFullCreditBalanceAvailable()"
              [formControl]="paymentValueControl"
            />
          </div>
          <label class="payments-balances__full-amount-label">
            <input
              type="checkbox"
              class="payments-balances__checkbox"
              [checked]="useFullCreditBalanceAvailable()"
              (change)="onToggleFullCreditBalanceAmount($event)"
            />
            {{ 'global.payments.advance-use-full-available' | translate }}
          </label>
        </div>
      }
    </div>
  }

  <div class="payments-methods">
    <h3 class="payments-methods__title">
      {{ 'global.payments.methods-title' | translate }}
    </h3>
    <div class="payments-methods__container">
      <div class="payments-methods__row">
        <div class="payments-methods__field payments-methods__field--method">
          <v-one-input
            type="select"
            [label]="'global.payments.payment-method' | translate"
            [placeholder]="'global.payments.select-placeholder' | translate"
            [required]="true"
            [options]="paymentMethodOptions"
            [formControl]="paymentMethodControl"
          />
        </div>
        <div class="payments-methods__field payments-methods__field--bank">
          <v-one-input
            type="select"
            [label]="'global.payments.bank-or-cashier' | translate"
            [placeholder]="'global.payments.select-placeholder' | translate"
            [required]="true"
            [disabled]="paymentMethodsDisabled"
            [options]="bankOrCashierOptions"
            [formControl]="bankOrCashierControl"
          />
        </div>
        <div class="payments-methods__field payments-methods__field--value">
          <v-one-input
            type="text"
            [label]="'global.payments.value' | translate"
            placeholder="$ 0"
            [required]="true"
            [disabled]="manualValueFieldLocked"
            [formControl]="paymentValueControl"
          />
          <label class="payments-methods__checkbox-label">
            <input
              type="checkbox"
              class="payments-methods__checkbox"
              [checked]="payFullAmount()"
              (change)="onPayFullAmountToggle($event)"
            />
            <span class="payments-methods__checkbox-text">{{
              'global.payments.pay-full-amount' | translate
            }}</span>
          </label>
        </div>
      </div>
      <div class="payments-methods__row">
        <div class="payments-methods__field payments-methods__field--date">
          <v-one-input
            type="date"
            [label]="'global.payments.date' | translate"
            [placeholder]="'global.payments.select-placeholder' | translate"
            [required]="true"
            [formControl]="dateControl"
          />
        </div>
        <div class="payments-methods__field payments-methods__field--reference">
          <v-one-input
            type="text"
            [label]="'global.payments.detail-observation' | translate"
            [placeholder]="'global.payments.write-placeholder' | translate"
            [required]="true"
            [formControl]="referenceControl"
          />
          <span class="payments-methods__char-count">{{
            'global.payments.char-count' | translate
          }}</span>
        </div>
        <div class="payments-methods__field payments-methods__field--action">
          <v-one-button
            [text]="'global.payments.add-payment' | translate"
            icon="add"
            variant="secondary"
            className="payments-methods__add-button"
            [disabled]="isAddingPayment()"
            (buttonClick)="addPayment()"
          />
        </div>
      </div>

      @if (addedPayments().length > 0) {
        <div class="payments-methods__entries">
          @for (entry of addedPayments(); track entry.id) {
            <div class="payments-methods__entry">
              <div class="payments-methods__entry-details">
                <div class="payments-methods__entry-field">
                  <span class="payments-methods__entry-label">{{
                    'global.payments.payment-method' | translate
                  }}</span>
                  <span class="payments-methods__entry-value">{{
                    entry.paymentMethodLabel
                  }}</span>
                </div>
                <div class="payments-methods__entry-field">
                  <span class="payments-methods__entry-label">{{
                    'global.payments.bank-or-cashier' | translate
                  }}</span>
                  <span class="payments-methods__entry-value">{{
                    entry.bankOrCashierLabel
                  }}</span>
                </div>
                <div class="payments-methods__entry-field">
                  <span class="payments-methods__entry-label">{{
                    'global.payments.value' | translate
                  }}</span>
                  <span class="payments-methods__entry-value">{{
                    entry.value | currency: 'USD'
                  }}</span>
                </div>
              </div>
              <button
                type="button"
                class="payments-methods__entry-delete"
                [attr.aria-label]="'global.payments.remove-payment' | translate"
                (click)="removePaymentEntry(entry.id)"
              >
                <v-one-icon name="trash" [color]="'var(--color-blue-700)'" />
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="payments-actions payments-actions--sticky">
    <v-one-button
      [text]="'global.payments.close' | translate"
      variant="outline"
      (buttonClick)="handleCloseButtonClick()"
    />
    <v-one-button
      [text]="'global.payments.submit-payment' | translate"
      variant="primary"
      [disabled]="addedPayments().length === 0 || isSubmittingPayments()"
      (buttonClick)="registerPayments()"
    />
  </div>
</ng-template>

<ng-template #historyTab>
  <ng-container *ngTemplateOutlet="summaryTiles"></ng-container>

  <h2 class="payments-history__title-heading">
    {{
      'global.payments.history-section-title'
        | translate: { invoice: invoiceConsecutiveNumber }
    }}
  </h2>
  <form>
    @if (currentInvoicePayments().length > 0) {
      <div>
        @for (list of currentInvoicePayments(); track list; let i = $index) {
          <div class="payments-history__entry">
            <div class="payments-history__status-icon">
              <v-one-icon
                [name]="
                  list.status >= appliedPaymentStatus
                    ? 'successCircle'
                    : 'pendingCircle'
                "
                [type]="iconType.FILLED"
                [color]="
                  list.status >= appliedPaymentStatus
                    ? 'var(--color-success-700)'
                    : 'var(--color-warning-700)'
                "
              />
            </div>
            <div class="payments-history__card">
              <div class="payments-history__header">
                <div class="payments-history__title-group">
                  <span class="payments-history__title">
                    {{ list.payment_description | translate }} #{{ i + 1 }} -
                    {{ list.date | date: 'dd/MM/yy' }}
                  </span>
                  <span
                    class="payments-history__badge"
                    [class.payments-history__badge--approved]="
                      list.status >= appliedPaymentStatus
                    "
                  >
                    {{ statusLabel(list.status) }}
                  </span>
                </div>
                @if (canManagePayments) {
                  <v-one-button
                    [text]="'global.payments.delete-button' | translate"
                    icon="trash"
                    variant="outline"
                    className="payments-history__delete-button"
                    [disabled]="
                      isDeletingPayment(list.id_payinvoice) ||
                      !canDeletePayment(list.id_payinvoice)
                    "
                    (buttonClick)="requestDeletePayment(list.id_payinvoice)"
                  />
                }
              </div>
              @if (isPendingDeleteConfirmation(list.id_payinvoice)) {
                <div class="payments-history__delete-confirm">
                  <div class="payments-history__delete-confirm-text">
                    <strong>{{
                      'global.payments.delete-confirm-title' | translate
                    }}</strong>
                    <p>
                      {{
                        'global.payments.delete-confirm-text'
                          | translate: { value: list.value }
                      }}
                    </p>
                  </div>
                  <div class="payments-history__delete-confirm-actions">
                    <v-one-button
                      [text]="
                        'global.payments.delete-confirm-cancel' | translate
                      "
                      variant="outline"
                      [disabled]="isDeletingPayment(list.id_payinvoice)"
                      (buttonClick)="cancelDeletePayment()"
                    />
                    <v-one-button
                      [text]="
                        'global.payments.delete-confirm-accept' | translate
                      "
                      icon="trash"
                      variant="primary"
                      [disabled]="isDeletingPayment(list.id_payinvoice)"
                      (buttonClick)="confirmDeletePayment(list)"
                    />
                  </div>
                </div>
              }
              <div class="payments-history__body">
                <div class="payments-history__details">
                  <div class="payments-history__row">
                    <span>{{
                      'global.payments.detail-id-label' | translate
                    }}</span>
                    <span>{{ list.identifier || '-' }}</span>
                  </div>
                  <div class="payments-history__row">
                    <span>{{
                      'global.payments.detail-transaction-label' | translate
                    }}</span>
                    <span>{{ list.id_correlative ?? '-' }}</span>
                  </div>
                  <div class="payments-history__row">
                    <span>{{
                      'global.payments.detail-type-label' | translate
                    }}</span>
                    <span>{{ list.payment_description | translate }}</span>
                  </div>
                  <div class="payments-history__row">
                    <span>{{ valueLabel(list) }}</span>
                    <span
                      class="payments-history__row--income"
                      [class.payments-history__row--pending]="
                        list.status < appliedPaymentStatus
                      "
                      >{{ list.value | currency: 'USD' }}</span
                    >
                  </div>
                  @if (isPendingApprovalForOperativo(list)) {
                    <div class="payments-history__row">
                      <span>{{
                        'global.payments.bank-or-cashier' | translate
                      }}</span>
                      <span>{{
                        list.paymentType?.[0]?.description ?? '-'
                      }}</span>
                    </div>
                  }
                  <div class="payments-history__row">
                    <span>{{
                      'global.payments.detail-approved-by' | translate
                    }}</span>
                    <span>
                      {{ approverName(list) }}
                      @if (list.cancelled_date) {
                        - {{ list.cancelled_date | date: 'dd/MM/yy HH:mm' }}
                      }
                    </span>
                  </div>
                  <div class="payments-history__row">
                    <span>{{
                      'global.payments.detail-observation' | translate
                    }}</span>
                    <span>{{ list.paymentDetails?.id_ref || '-' }}</span>
                  </div>
                </div>
                @if (isPendingApprovalForOperativo(list)) {
                  <div class="payments-history__banner">
                    <strong>{{
                      'global.payments.pending-banner-title' | translate
                    }}</strong>
                    <p>
                      {{ 'global.payments.pending-banner-text' | translate }}
                    </p>
                  </div>
                }
              </div>
              @if (getTransferDetails(list.id_payinvoice); as transfer) {
                <div class="payments-history__transfer">
                  <span class="payments-history__transfer-label">{{
                    'global.payments.history-transfer-label' | translate
                  }}</span>
                  <span>{{ transfer.originLabel }}</span>
                  <v-one-icon name="arrowRight" [type]="iconType.FILLED" />
                  <span>{{ transfer.destinationLabel }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (currentInvoicePayments().length <= 0) {
      <div class="payments-empty-state">
        <strong class="payments-empty-state__title">{{
          'global.payments.history-empty-title' | translate
        }}</strong>
        <p class="payments-empty-state__text">
          {{ 'global.payments.history-empty-text' | translate }}
        </p>
      </div>
    }
  </form>

  <div class="payments-actions payments-actions--sticky">
    <v-one-button
      [text]="'global.payments.close' | translate"
      variant="primary"
      (buttonClick)="handleCloseButtonClick()"
    />
  </div>
</ng-template>

<ng-template #approveTab>
  <ng-container *ngTemplateOutlet="summaryTiles"></ng-container>

  @if (approvalConfirmation(); as confirmation) {
    <div class="payments-approve__confirmation">
      <div class="payments-approve__confirmation-icon">
        <v-one-icon
          name="successCircle"
          [type]="iconType.FILLED"
          color="var(--color-success-700)"
        />
      </div>
      <h3 class="payments-approve__confirmation-title">
        {{ 'global.payments.approval-success-title' | translate }}
      </h3>
      <p class="payments-approve__confirmation-subtitle">
        {{
          (confirmation.isInvoiceComplete
            ? 'global.payments.approval-success-invoice-complete'
            : 'global.payments.approval-success-generic'
          ) | translate: { invoice: invoiceConsecutiveNumber }
        }}
      </p>

      <h4 class="payments-approve__summary-title">
        {{ 'global.payments.approval-summary-title' | translate }}
      </h4>
      <div class="payments-approve__summary-box">
        <div class="payments-approve__summary-row">
          <span>{{
            'global.payments.approval-summary-value' | translate
          }}</span>
          <strong>{{ confirmation.value | currency: 'USD' }}</strong>
        </div>
        <div class="payments-approve__summary-row">
          <span>{{
            'global.payments.approval-summary-origin' | translate
          }}</span>
          <strong class="payments-approve__summary-value--plain">{{
            confirmation.originLabel
          }}</strong>
        </div>
        <div class="payments-approve__summary-row">
          <span>{{
            'global.payments.approval-summary-destination' | translate
          }}</span>
          <strong class="payments-approve__summary-value--plain">{{
            confirmation.destinationLabel
          }}</strong>
        </div>
      </div>
    </div>
  } @else {
    @if (pendingApprovalPayments.length === 0) {
      <div class="payments-empty-state">
        <strong class="payments-empty-state__title">{{
          'global.payments.approve-empty-title' | translate
        }}</strong>
        <p class="payments-empty-state__text">
          {{ 'global.payments.approve-empty-text' | translate }}
        </p>
      </div>

      <div class="payments-actions payments-actions--sticky">
        <v-one-button
          [text]="'global.payments.close' | translate"
          variant="primary"
          (buttonClick)="handleCloseButtonClick()"
        />
      </div>
    }

    @for (payment of pendingApprovalPayments; track payment.id_payinvoice) {
      <div class="payments-approve__card">
        <div class="payments-approve__header">
          <span>
            {{ 'global.payments.approve-card-date-prefix' | translate }}
            {{ payment.date | date: 'dd/MM/yy' }}
          </span>
          <span class="payments-history__badge">
            {{ statusLabel(payment.status) }}
          </span>
        </div>

        <div class="payments-history__details">
          <div class="payments-history__row">
            <span>{{
              'global.payments.detail-registration-type' | translate
            }}</span>
            <span>{{ payment.payment_description | translate }}</span>
          </div>
          <div class="payments-history__row">
            <span>{{
              'global.payments.detail-seller-cashier' | translate
            }}</span>
            <span>{{ payment.paymentType?.[0]?.description ?? '-' }}</span>
          </div>
          <div class="payments-history__row">
            <span>{{ valueLabel(payment) }}</span>
            <span class="payments-history__row--income">{{
              payment.value | currency: 'USD'
            }}</span>
          </div>
          <div class="payments-history__row">
            <span>{{ 'global.payments.detail-observation' | translate }}</span>
            <span>{{ payment.paymentDetails?.id_ref || '-' }}</span>
          </div>
        </div>

        <div class="payments-approve__transfer">
          <div class="payments-approve__transfer-header">
            {{ 'global.payments.transfer-section-title' | translate }}
          </div>
          <div class="payments-approve__transfer-body">
            <div class="payments-approve__transfer-row">
              <div class="payments-approve__transfer-field">
                <v-one-input
                  type="select"
                  [label]="'global.payments.transfer-origin-label' | translate"
                  [options]="originOptions(payment)"
                  [formControl]="getOriginControl(payment)"
                  [disabled]="true"
                />
              </div>
              <v-one-icon
                class="payments-approve__transfer-arrow"
                name="arrowRight"
                [type]="iconType.FILLED"
              />
              <div class="payments-approve__transfer-field">
                <v-one-input
                  type="select"
                  [label]="
                    'global.payments.transfer-destination-label' | translate
                  "
                  [placeholder]="
                    'global.payments.select-placeholder' | translate
                  "
                  [required]="true"
                  [options]="destinationOptions"
                  [formControl]="getDestinationControl(payment.id_payinvoice)"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="payments-approve__transfer-note">
          <p>{{ 'global.payments.transfer-confirm-info' | translate }}</p>
        </div>

        <div class="payments-actions">
          <v-one-button
            [text]="'global.payments.approve-and-transfer-button' | translate"
            variant="primary"
            [disabled]="isProcessingApproval(payment.id_payinvoice)"
            (buttonClick)="approveAndTransfer(payment)"
          />
        </div>
      </div>
    }
  }
</ng-template>

<ng-template #invoiceDetailTab>
  <ng-container *ngTemplateOutlet="summaryTiles"></ng-container>

  <div class="invoice-detail">
    <div class="invoice-detail__section">
      <div class="invoice-detail__section-header">
        {{ 'global.payments.detail-section-title' | translate }}
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-invoice-number' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          invoiceConsecutiveNumber || '-'
        }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-dian-consecutive' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          dianInvoiceNumber || '-'
        }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-customer' | translate
        }}</span>
        <span class="invoice-detail__value">{{ customerName }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-nit' | translate
        }}</span>
        <span class="invoice-detail__value">{{ customerNit }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-seller' | translate
        }}</span>
        <span class="invoice-detail__value">{{ sellerName }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-creation-date' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          quotation().createdAt
            ? (quotation().createdAt | date: 'dd/MM/yyyy')
            : '-'
        }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.detail-due-date' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          quotation().dueDate ? (quotation().dueDate | date: 'dd/MM/yyyy') : '-'
        }}</span>
      </div>
    </div>

    <div class="invoice-detail__section">
      <div class="invoice-detail__section-header">
        {{ 'global.payments.financial-summary-title' | translate }}
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.financial-original-total' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          originalInvoiceTotal() | currency: 'USD'
        }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.financial-nc-nd-adjustment' | translate
        }}</span>
        <span
          class="invoice-detail__value"
          [class.invoice-detail__value--negative]="ncNdAdjustment() < 0"
          [class.invoice-detail__value--info]="ncNdAdjustment() > 0"
          >{{ ncNdAdjustment() | currency: 'USD' }}</span
        >
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.financial-adjusted-total' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          totalQuot() | currency: 'USD'
        }}</span>
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.financial-paid-total' | translate
        }}</span>
        <span
          class="invoice-detail__value"
          [class.invoice-detail__value--positive]="appliedPaidTotal > 0"
          >{{ appliedPaidTotal | currency: 'USD' }}</span
        >
      </div>
      <div class="invoice-detail__row">
        <span class="invoice-detail__label">{{
          'global.payments.financial-pending-balance' | translate
        }}</span>
        <span class="invoice-detail__value">{{
          appliedPendingBalance | currency: 'USD'
        }}</span>
      </div>
    </div>

    @if (currentInvoicePayments().length > 0) {
      <div class="invoice-detail__section">
        <div class="invoice-detail__section-header">
          {{ 'global.payments.received-payments-title' | translate }}
        </div>
        @for (
          payment of sortedInvoicePayments;
          track payment.id_payinvoice;
          let i = $index
        ) {
          <div class="invoice-detail__payment-row">
            <div class="invoice-detail__payment-title">
              <span class="invoice-detail__payment-number">{{
                'global.payments.payment-number' | translate: { number: i + 1 }
              }}</span>
              <span class="invoice-detail__payment-classification">{{
                (payment.isFullPayment
                  ? 'global.payments.full-payment-label'
                  : 'global.payments.partial-payment-label'
                ) | translate
              }}</span>
            </div>
            <div class="invoice-detail__payment-meta">
              <span class="invoice-detail__payment-date">{{
                payment.date | date: 'dd/MM/yy'
              }}</span>
              <span class="invoice-detail__payment-badge">{{
                payment.value | currency: 'USD'
              }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="payments-actions payments-actions--sticky">
    <v-one-button
      [text]="'global.payments.close' | translate"
      [variant]="isVoidedInvoice ? 'primary' : 'outline'"
      (buttonClick)="handleCloseButtonClick()"
    />
    @if (!isVoidedInvoice) {
      <v-one-button
        [text]="'global.payments.generate-receipt-button' | translate"
        variant="primary"
        (buttonClick)="generateReceipt()"
      />
    }
  </div>
</ng-template>
